import { Map } from 'immutable';

/**
 * Custom messages for transpennine
 */

module.exports = new Map({
    'app.owner': 'TransPennine Express',
    'app.owner.toc': 'TPE',
    'app.owner.short': 'TransPennine Express',
    'app.owner.appName': 'TransPennine Express',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.nav.reservations': 'Reservations',

    'login.username': 'Email address',
    'customerdetails.email': 'Email address',
    'promotion.tocFamily.email.label': 'Email address',

    'ontrackapp.widget.title': 'Meet the {brand} App',

    'preference-centre.privacy-notice': '_',
    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TransPennine Express. Please log in or use a different email address.',
});



// WEBPACK FOOTER //
// ./src/messages/transpennine.js